/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Wizard_How_Approvals_ValueInputs */



/**
* | output |
* | --- |
* | "Asks before acting outside oneAI" |
*
* @param {Agent_Wizard_How_Approvals_ValueInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_wizard_how_approvals_value = /** @type {((inputs?: Agent_Wizard_How_Approvals_ValueInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Wizard_How_Approvals_ValueInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Fragt, bevor er außerhalb von oneAI handelt")
	return /** @type {LocalizedString} */ ("Asks before acting outside oneAI")
});